import React from 'react';
import './Cdqheadergal.css'; // Importe le CSS
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche


function Cdqgalerie() {
  return (
    <div className="header-containerga24">
        <div className="boutton-containerga24">
                <div className='butga1'>
                  
             <button className="bouttonga24">ACCUEIL<ArrowForwardIcon className="24arrow-icon" />Chefs de quartiers et Cdq</button>
             <h1>Chefs de quartiers et Cdq</h1> 
            </div>
            </div>
    </div>
  );
}

export default Cdqgalerie;


